/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Collections_Description_OverviewInputs */

const id_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game terlaris, paling banyak dimainkan, dan terpopuler di Epic Games Store`)
};

const ms_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan terlaris, paling banyak dimainkan, dan paling popular di Epic Games Store`)
};

const da_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De bedst sælgende, mest spillede og mest populære spil på Epic Games Store`)
};

const de_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die meistverkauften, meistgespielten und beliebtesten Spiele im Epic Games Store`)
};

const en_us2_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The top sellers, most played, and most popular games on the Epic Games Store`)
};

const es_es2_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los más vendidos, más jugados y más populares en la Epic Games Store`)
};

const es_mx2_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los juegos más vendidos, más jugados y más populares en la Epic Games Store`)
};

const fil_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang mga pinakamabenta, pinakamalaro, at pinakasikat na laro sa Epic Games Store`)
};

const fr_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les meilleures ventes, les plus joués et les jeux les plus populaires sur l'Epic Games Store`)
};

const it_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I giochi più venduti, più giocati e più popolari sull'Epic Games Store`)
};

const hu_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A legkelendőbb, legtöbbet játszott és legnépszerűbb játékok az Epic Games Store-ban`)
};

const nl_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De best verkopende, meest gespeelde en populairste games in de Epic Games Store`)
};

const no_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De mest solgte, mest spilte og mest populære spillene på Epic Games Store`)
};

const pl_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najlepiej sprzedające się, najczęściej grane i najpopularniejsze gry w Epic Games Store`)
};

const pt_br2_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os jogos mais vendidos, mais jogados e mais populares na Epic Games Store`)
};

const pt_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os mais vendidos, mais jogados e mais populares na Epic Games Store`)
};

const ro_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cele mai vândute, cele mai jucate și cele mai populare jocuri pe Epic Games Store`)
};

const fi_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Myydyimmät, pelatuimmat ja suosituimmat pelit Epic Games Storessa`)
};

const sv_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De bästsäljande, mest spelade och mest populära spelen på Epic Games Store`)
};

const vi_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các game bán chạy nhất, chơi nhiều nhất và phổ biến nhất trên Epic Games Store`)
};

const tr_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store'daki en çok satanlar, en çok oynananlar ve en popüler oyunlar`)
};

const cs_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejprodávanější, nejhranější a nejoblíbenější hry na Epic Games Store`)
};

const bg_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-продаваните, най-играните и най-популярните игри в Epic Games Store`)
};

const ru_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самые продаваемые, самые популярные и самые любимые игры в Epic Games Store`)
};

const uk_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найпродаваніші, найпопулярніші та найулюбленіші ігри в Epic Games Store`)
};

const ar_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأكثر مبيعًا والأكثر لعبًا والأكثر شعبية في Epic Games Store`)
};

const hi_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store पर टॉप सेलर, सबसे ज़्यादा खेले गए और सबसे लोकप्रिय गेम`)
};

const th_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมขายดี เล่นมากที่สุด และยอดนิยมบน Epic Games Store`)
};

const ja_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store のトップセラー、最もプレイされた、最も人気のあるゲーム`)
};

const zh_cn2_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic游戏商城中最畅销、游玩人数最多以及最受欢迎的游戏`)
};

const zh_hant1_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic遊戲商城中最暢銷、遊玩人數最多以及最受歡迎的遊戲`)
};

const ko_collections_description_overview = /** @type {(inputs: Collections_Description_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store의 최고 판매, 최다 플레이, 가장 인기 있는 게임`)
};

/**
* | output |
* | --- |
* | "The top sellers, most played, and most popular games on the Epic Games Store" |
*
* @param {Collections_Description_OverviewInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const collections_description_overview = /** @type {((inputs?: Collections_Description_OverviewInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Collections_Description_OverviewInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_collections_description_overview(inputs)
	if (locale === "ms") return ms_collections_description_overview(inputs)
	if (locale === "da") return da_collections_description_overview(inputs)
	if (locale === "de") return de_collections_description_overview(inputs)
	if (locale === "en-US") return en_us2_collections_description_overview(inputs)
	if (locale === "es-ES") return es_es2_collections_description_overview(inputs)
	if (locale === "es-MX") return es_mx2_collections_description_overview(inputs)
	if (locale === "fil") return fil_collections_description_overview(inputs)
	if (locale === "fr") return fr_collections_description_overview(inputs)
	if (locale === "it") return it_collections_description_overview(inputs)
	if (locale === "hu") return hu_collections_description_overview(inputs)
	if (locale === "nl") return nl_collections_description_overview(inputs)
	if (locale === "no") return no_collections_description_overview(inputs)
	if (locale === "pl") return pl_collections_description_overview(inputs)
	if (locale === "pt-BR") return pt_br2_collections_description_overview(inputs)
	if (locale === "pt") return pt_collections_description_overview(inputs)
	if (locale === "ro") return ro_collections_description_overview(inputs)
	if (locale === "fi") return fi_collections_description_overview(inputs)
	if (locale === "sv") return sv_collections_description_overview(inputs)
	if (locale === "vi") return vi_collections_description_overview(inputs)
	if (locale === "tr") return tr_collections_description_overview(inputs)
	if (locale === "cs") return cs_collections_description_overview(inputs)
	if (locale === "bg") return bg_collections_description_overview(inputs)
	if (locale === "ru") return ru_collections_description_overview(inputs)
	if (locale === "uk") return uk_collections_description_overview(inputs)
	if (locale === "ar") return ar_collections_description_overview(inputs)
	if (locale === "hi") return hi_collections_description_overview(inputs)
	if (locale === "th") return th_collections_description_overview(inputs)
	if (locale === "ja") return ja_collections_description_overview(inputs)
	if (locale === "zh-CN") return zh_cn2_collections_description_overview(inputs)
	if (locale === "zh-Hant") return zh_hant1_collections_description_overview(inputs)
	return ko_collections_description_overview(inputs)
});
export { collections_description_overview as "collections.description.overview" }